import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import VisibilityCriteriaEmptyState from './VisibilityCriteriaEmptyState/VisibilityCriteriaEmptyState'

const VisibilityCriteriaSelector = ({
  selectedCriterionIds,
  onChange,
  criteriaOptions,
  loading,
  onGoToCriteria,
  error,
}) => {
  const { t } = useTranslation()

  const handleChange = event => onChange(event.target.value)

  if (!loading && !criteriaOptions.length) return <VisibilityCriteriaEmptyState onGoToCriteria={onGoToCriteria} />

  const menuItems = criteriaOptions.map(criterion => ({
    value: criterion.id,
    label: `${criterion.internal_id} | ${criterion.name}`,
  }))

  return (
    <ComboBox
      multiple
      fullWidth
      label={t('Criterios de visibilidad')}
      value={selectedCriterionIds}
      handleChange={handleChange}
      menuItems={menuItems}
      loading={loading}
      error={error}
      helperText={error ? t('Este campo es obligatorio') : ''}
    />
  )
}

export default VisibilityCriteriaSelector
